import legendItemWidget from "../../../core/widgets/legendItemWidget.js";

/**
 * Base class for the company chart legend items.
 * Takes care of the pop over and suppresses the legend click event.
 */
function companyChartLegendItemWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = legendItemWidget(spec, my);

	my.popover = undefined;

	that.setPopoverValues = function (companyBalance) {
		my.popover = my.createPopover(companyBalance);
	};

	that.renderContentOn = function (html) {
		const div = html.div(my.renderLegendItemContentOn);
		if (my.popover) {
			my.popover.setTriggerItem(div);
		}
	};

	my.legendClick = function () {
		// Explicit do nothing
	};

	my.createPopover = function (_companyBalance) {
		// Override this in the concrete subclasses
		throw new Error("Create popover is not implemented");
	};

	my.isActive = function () {
		return true;
	};

	return that;
}

export default companyChartLegendItemWidget;
